import { CircleCheck, Info, LoaderCircle, OctagonX, TriangleAlert } from "lucide-react";
import type { CSSProperties } from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

/**
 * The one toast outlet an app mounts, styled from the same tokens as every other
 * component here. `theme` defaults to dark, the palette globals.css puts on :root; the
 * dashboard passes the theme it resolved from the user's choice. Fire toasts with the
 * `toast` export below.
 */
function Toaster({ theme = "dark", ...props }: ToasterProps) {
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <CircleCheck className="size-4" />,
        info: <Info className="size-4" />,
        warning: <TriangleAlert className="size-4" />,
        error: <OctagonX className="size-4" />,
        loading: <LoaderCircle className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as CSSProperties
      }
      {...props}
    />
  );
}

// biome-ignore lint/performance/noBarrelFile: one re-export; the dashboard has no sonner dependency to import direct.
export { toast } from "sonner";
export { Toaster };
